// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"6e82301c","551":"2a37cce4","828":"89358f49","842":"8df647c5"}[chunkId] + ".chunk.js";
};